<template>
  <div id="home-section-wrapper">
    <div class="home-section-title-container">
      <p class="home-section-subtitle">Bienvenido a nuestra</p>
      <h3 class="home-section-title">INTELIGENCIA ARTIFICIAL</h3>
    </div>

    <div class="home-section-content-wrapper">
      <div class="home-section-new-card" v-if="isNewUser">
        <p class="home-section-new-title">
          Por favor crea tu nuevo
          <span class="txt-bold">espacio de trabajo</span>
        </p>

        <button class="home-section-new-btn" @click="getNew">
          <span class="txt-bold">Nuevo</span>
        </button>
      </div>

      <div class="home-section-table-card" v-else>
        <p class="home-section-table-title txt-grad-color-2">
          Disfruta de cada <span class="txt-bold">espacio de trabajo</span> que
          creaste.
        </p>

        <button class="home-section-table-btn" type="button" @click="getNew">
          <span class="txt-bold">Nuevo</span>
        </button>

        <div class="home-section-table-header">
          <p class="home-section-table-label txt-bold">Plantilla</p>
          <p class="home-section-table-label txt-bold">Nombre</p>
          <p class="home-section-table-label txt-bold">Valorar</p>
          <p class="home-section-table-label txt-bold">Compartir</p>
          <p class="home-section-table-label txt-bold">Eliminar</p>
        </div>

        <div class="home-section-table">
          <div
            class="home-section-table-line-bg"
            v-for="(plan, index) in plantillas"
            :key="plan.id_plantilla"
            @click="setActive($event)"
          >
            <div class="home-section-table-line">
              <div class="home-section-table-plantilla-label-field txt-bold">
                Plantilla:
              </div>
              <div
                class="home-section-table-plantilla-field txt-grad-color-2 txt-bold"
              >
                {{ index + 1 }}
              </div>
              <div class="home-section-table-nombre-label-field txt-bold">
                Nombre:
              </div>
              <div class="home-section-table-nombre-field">
                {{ plan.nombre_plantilla }}
              </div>
              <div class="home-section-table-valorar-field">
                <button
                  type="button"
                  class="home-section-valorar-btn"
                  @click="getConfirmEvaluate(plan)"
                  :disabled="modalEvaluate.loading"
                >
                  <b-icon
                    icon="ui-checks"
                    v-if="!modalEvaluate.loading"
                  ></b-icon>
                  <div class="lds-ring" v-if="modalEvaluate.loading">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <span class="txt-bold">Valorar</span>
                </button>
              </div>

              <div class="home-section-table-share-field">
                <button
                  type="button"
                  class="home-section-share-btn"
                  @click="getConfirmShare(plan)"
                >
                  <b-icon icon="share-fill"></b-icon>
                  <span class="txt-bold">Compartir</span>
                </button>
              </div>

              <div class="home-section-table-eliminar-field">
                <button
                  type="button"
                  class="home-section-eliminar-btn"
                  @click="getConfirmDelete(plan)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                  <span class="txt-bold">Eliminar</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home-section-modals-wrapper">
      <b-modal
        v-model="modalEvaluate.show"
        id="home-modal-evaluate"
        size="lg"
        centered
        no-close-on-backdrop
        no-close-on-esc
      >
        <template #modal-header>
          <h5 class="modal-title">{{ modalEvaluate.title }}</h5>
          <button
            type="button"
            class="home-modal-evaluate-close-btn"
            @click="modalEvaluate.show = false"
          >
            <b-icon icon="x"></b-icon>
          </button>
        </template>

        <div class="home-modal-evaluate-body">
          <p class="home-modal-evaluate-txt" v-html="modalEvaluate.text"></p>
          <button
            class="home-modal-evaluate-excel-btn txt-bold"
            type="button"
            v-if="modalEvaluate.pending"
            @click="getDownloadExcel(modalEvaluate.plantillaEvaluar)"
          >
            <b-icon
              class="home-modal-evaluate-excel-icon"
              icon="file-earmark-x"
            ></b-icon>
            Exportar Excel
          </button>
        </div>

        <template #modal-footer>
          <button
            type="button"
            class="home-modal-evaluate-normal-btn txt-bold"
            @click="getDeleteEvaluations(modalEvaluate.plantillaEvaluar)"
            v-if="modalEvaluate.pending"
          >
            {{ modalEvaluate.normalBtnText }}
          </button>

          <button
            type="button"
            class="home-modal-evaluate-grad-btn"
            @click="getEvaluate(modalEvaluate.plantillaEvaluar)"
          >
            <span class="txt-bold">{{ modalEvaluate.gradBtnText }}</span>
          </button>
        </template>
      </b-modal>

      <b-modal
        v-model="modalShare.show"
        id="home-modal-share"
        centered
        size="md"
        hide-footer
      >
        <template #modal-header>
          <button
            type="button"
            class="home-modal-share-close-btn"
            @click="modalShare.show = false"
          >
            <b-icon icon="x"></b-icon>
          </button>
        </template>

        <div class="home-modal-share-body">
          <picture>
            <source srcset="../../assets/img/logo-MEC.webp" type="image/webp" />
            <source srcset="../../assets/img/logo-MEC.png" type="image/png" />
            <img
              src="../../assets/img/logo-MEC.png"
              alt="Logo MEC"
              width="76"
              height="42"
            />
          </picture>

          <form
            class="home-modal-share-form"
            @submit.prevent="getShare(modalShare.plantillaCompartir)"
          >
            <h5 class="home-modal-share-form-title txt-bold">
              Comparte tu experiencia
            </h5>

            <p class="home-modal-share-form-txt">
              Comparte tus plantillas y aprovecha todo el potencial de las
              valoraciones con Inteligencia Artificial que tiene el MEC.
            </p>

            <input
              class="home-modal-share-form-input"
              placeholder="Escribe una dirección de email"
              type="email"
              v-model="formShare.correos[0]"
            />

            <input
              class="home-modal-share-form-input"
              placeholder="Escribe una dirección de email"
              type="email"
              v-model="formShare.correos[1]"
            />

            <input
              class="home-modal-share-form-input"
              placeholder="Escribe una dirección de email"
              type="email"
              v-model="formShare.correos[2]"
            />

            <p
              class="home-modal-share-invalid-feedback txt-bold"
              v-if="formShare.errorFeedback"
            >
              {{ formShare.errorFeedback }}
            </p>

            <button
              class="home-modal-share-form-btn"
              type="submit"
              :disabled="modalShare.loading"
            >
              <span class="txt-bold">
                <div class="lds-ring" v-if="modalShare.loading">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                {{
                  modalShare.loading ? "Enviando..." : "Enviar invitación"
                }}</span
              >
            </button>
          </form>
        </div>
      </b-modal>

      <b-modal
        v-model="modalDelete.show"
        id="home-modal-delete"
        centered
        no-close-on-backdrop
        no-close-on-esc
      >
        <template #modal-header>
          <h5 class="modal-title">{{ modalDelete.title }}</h5>
          <button
            type="button"
            class="home-modal-delete-close-btn"
            @click="modalDelete.show = false"
          >
            <b-icon icon="x"></b-icon>
          </button>
        </template>

        <div class="home-modal-delete-body">
          <p class="home-modal-delete-txt" v-html="modalDelete.text"></p>
        </div>
        <template #modal-footer>
          <button
            type="button"
            class="home-modal-delete-normal-btn txt-bold"
            @click="modalDelete.show = false"
          >
            {{ modalDelete.normalBtnText }}
          </button>

          <button
            type="button"
            class="home-modal-delete-grad-btn"
            @click="getDelete(modalDelete.plantillaEliminar)"
            :disabled="modalDelete.loading"
          >
            <span class="txt-bold">
              <div class="lds-ring" v-if="modalDelete.loading">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              {{ modalDelete.gradBtnText }}</span
            >
          </button>
        </template>
      </b-modal>

      <b-modal v-model="modalWarn.show" id="home-modal-warn" centered>
        <template #modal-header>
          <h5 class="modal-title">{{ modalWarn.title }}</h5>
          <button
            type="button"
            class="home-modal-warn-close-btn"
            @click="modalWarn.show = false"
          >
            <b-icon icon="x"></b-icon>
          </button>
        </template>

        <div class="home-modal-warn-body">
          <p class="home-modal-warn-txt" v-html="modalWarn.text"></p>
        </div>

        <template #modal-footer>
          <button
            type="button"
            class="home-modal-warn-grad-btn"
            @click="modalWarn.show = false"
          >
            <span class="txt-bold">{{ modalWarn.gradBtnText }}</span>
          </button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import MEC_Plantillas_api from "@/modules/MEC_Plantillas_api";
import MEC_Momentos_api from "@/modules/MEC_Momentos_api";
import MEC_Calificaciones_api from "@/modules/MEC_Calificaciones_api";
import MEC_Plantillas_compartidas_api from "@/modules/MEC_Plantillas_compartidas_api";

//@Hace referencia a toda la funcionalidad de vue, metodos y variables
var varSelf = null;

export default {
  data() {
    return {
      //id_funcionario: 369,
      modalEvaluate: {
        loading: false,
        show: false,
        pending: false,
        title: "Evaluar",
        text: "Esto es un texto de prueba",
        normalBtnText: "Cancelar",
        gradBtnText: "Exitoso",
        plantillaEvaluar: {},
      },
      modalDelete: {
        loading: false,
        show: false,
        title: "Eliminar",
        text: "Esto es un texto de prueba",
        normalBtnText: "Cancelar",
        gradBtnText: "Exitoso",
        plantillaEliminar: {},
      },
      modalWarn: {
        show: false,
        title: "Aviso",
        text: "Esto es un texto de prueba",
        normalBtnText: "Cancelar",
        gradBtnText: "Exitoso",
      },
      modalShare: {
        show: false,
        loading: false,
        plantillaCompartir: {},
      },
      formShare: {
        correos: [],
        errorFeedback: "",
      },
      plantillas: [
        // {
        //   id: 1,
        //   plantilla: "P1",
        //   nombre_plantilla: "Lógica de Programación",
        //   numero_d_momentos: "5",
        //   arrayPorcentajes: ["10", "10", "10", "20", "50"],
        // },
        // {
        //   id: 2,
        //   plantilla: "P2",
        //   nombre_plantilla: "Lógica de Programación orientada a objetos ",
        //   numero_d_momentos: "4",
        //   arrayPorcentajes: ["25", "25", "25", "25"],
        // },
        // {
        //   id: 3,
        //   plantilla: "P3",
        //   nombre_plantilla: "Lógica de Programación II",
        //   numero_d_momentos: "2",
        //   arrayPorcentajes: ["70", "30"],
        // },
      ],
    };
  },

  computed: {
    isNewUser() {
      return this.plantillas.length === 0;
    },
  },

  props: ["id_funcionario", "recargasSesion"],

  watch: {
    recargasSesion() {
      this.getAll();
    },
  },

  created() {
    varSelf = this;
  },

  mounted() {
    //@Carga la lista de plantillas
    varSelf.getAll();
  },

  methods: {
    getNew() {
      this.$emit("sectionChange", { section: "creation", lastSection: "home" });
    },

    async getConfirmEvaluate(plantilla) {
      this.modalEvaluate.loading = true;

      const apiCalificaciones = new MEC_Calificaciones_api();

      await apiCalificaciones
        .nro_calificaciones_plantilla(plantilla.id_plantilla)
        .then((result) => {
          this.modalEvaluate.plantillaEvaluar = plantilla;

          if (result.data.result.Calificados > 0) {
            this.modalEvaluate.pending = true;
            this.modalEvaluate.title = `Actualmente tienes ${
              result.data.result.Calificados
            } ${
              result.data.result.Calificados > 1
                ? "valoraciones abiertas"
                : "valoración abierta"
            }.`;
            this.modalEvaluate.text = `Por favor selecciona si quieres continuar con las valoraciones en la plantilla <span class="txt-bold">${plantilla.nombre_plantilla}</span>, descargar la lista de valoraciones pendientes en Excel, o si deseas reiniciar el proceso.`;
            this.modalEvaluate.gradBtnText = "Continuar";
            this.modalEvaluate.normalBtnText = "Reiniciar";
            this.modalEvaluate.show = true;
            this.modalEvaluate.loading = false;
          } else if (result.data.result.Calificados == 0) {
            this.modalEvaluate.pending = false;
            this.modalEvaluate.title = `Evaluar`;
            this.modalEvaluate.text = `Has seleccionado la plantilla <span class="txt-bold">${plantilla.nombre_plantilla}</span>, para empezar a evaluar haz click en continuar.`;
            this.modalEvaluate.gradBtnText = "Continuar";
            this.modalEvaluate.normalBtnText = "";
            this.modalEvaluate.show = true;
            this.modalEvaluate.loading = false;
          } else {
            this.modalEvaluate.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getDeleteEvaluations(plantilla) {
      const apiCalificaciones = new MEC_Calificaciones_api();

      apiCalificaciones
        .borrar_calificaciones_plantilla(plantilla.id_plantilla)
        .then((result) => {
          this.modalEvaluate.show = false;

          if (result.data.result.rowsAffected[0] > 0) {
            this.modalWarn.show = true;
            this.modalWarn.title = "Valoraciones borradas";
            this.modalWarn.text =
              "Las valoraciones pendientes de la plantilla han sido borradas exitosamente.";
            this.modalWarn.gradBtnText = "Aceptar";
          } else {
            this.modalWarn.show = true;
            this.modalWarn.title = "Error";
            this.modalWarn.text =
              "Ha ocurrido un error al compartir la plantilla, inténtalo de nuevo.";
            this.modalWarn.gradBtnText = "Aceptar";
          }
          return result;
        })
        .catch((err) => {
          this.modalEvaluate.show = false;
          return err;
        });
    },

    getDownloadExcel(plantilla) {
      const apiCalificaciones = new MEC_Calificaciones_api();

      apiCalificaciones
        .reporte_x_plantilla(plantilla.id_plantilla)
        .then((result) => {
          this.modalEvaluate.show = false;
          return result;
        })
        .catch((err) => {
          this.modalEvaluate.show = false;
          return err;
        });
    },

    getEvaluate(plantilla) {
      this.$emit("getEvaluate", plantilla);
    },

    getConfirmShare(plantilla) {
      this.modalShare.plantillaCompartir = plantilla;
      this.modalShare.show = true;
    },

    async getShare(plantilla) {
      const apiPlantillasCompartidas = new MEC_Plantillas_compartidas_api();
      this.modalShare.loading = true;

      if (!this.validateShareForm()) {
        this.modalShare.loading = false;
        return;
      }

      await apiPlantillasCompartidas
        .compartirPlantilla(
          plantilla.id_plantilla,
          this.id_funcionario,
          this.formShare.correos[0],
          this.formShare.correos[1],
          this.formShare.correos[2]
        )
        .then((result) => {
          if (result.data.enviosInfo) {
            result.data.enviosInfo[0].status == "OK"
              ? this.handleCloseModalShare(true)
              : this.handleCloseModalShare(false);
          } else {
            this.handleCloseModalShare(false);
          }
        })
        .catch((err) => {
          this.handleCloseModalShare(false);
          console.log(err);
        });
    },

    handleCloseModalShare(success) {
      this.formShare.correos = [];

      if (success) {
        this.modalShare.loading = false;
        this.modalShare.show = false;
        this.modalWarn.show = true;
        this.modalWarn.title = "Plantilla Compartida";
        this.modalWarn.text = "La plantilla ha sido compartida exitosamente.";
        this.modalWarn.gradBtnText = "Aceptar";
      } else {
        this.modalShare.loading = false;
        this.modalShare.show = false;
        this.modalWarn.show = true;
        this.modalWarn.title = "Error";
        this.modalWarn.text =
          "Ha ocurrido un error al compartir la plantilla, inténtalo de nuevo.";
        this.modalWarn.gradBtnText = "Aceptar";
      }
    },

    validateShareForm() {
      this.formShare.errorFeedback = "";

      if (
        !this.formShare.correos[0] &&
        !this.formShare.correos[1] &&
        !this.formShare.correos[2]
      ) {
        this.formShare.errorFeedback = "Debes digitar al menos un correo";
        return false;
      } else {
        return true;
      }
    },

    getConfirmDelete(plantilla) {
      this.modalDelete.show = true;
      this.modalDelete.gradBtnText = "Aceptar";
      this.modalDelete.normalBtnText = "Cancelar";
      this.modalDelete.title = "Eliminar Plantilla";
      this.modalDelete.text = `¿Deseas eliminar la plantilla <span class="txt-bold">${plantilla.nombre_plantilla}</span>?`;
      this.modalDelete.plantillaEliminar = plantilla;
    },

    async getDelete(plantilla) {
      this.modalDelete.loading = true;

      var api_p = new MEC_Plantillas_api();
      await api_p
        .delete(plantilla.id_plantilla)
        .then(function (prmRes) {
          return prmRes;
        })
        .then(function (prmData) {
          if (prmData.data.rowsAffected == 1) {
            //@Carga la lista de plantillas
            varSelf.getAll();
          }
        });

      var api_m = new MEC_Momentos_api();
      await api_m
        .delete_id(plantilla.id_plantilla)
        .then(function (prmRes) {
          return prmRes;
        })
        .then(function (prmData) {
          return prmData;
        });

      var api_c = new MEC_Calificaciones_api();
      await api_c
        .delete_id(plantilla.id_plantilla)
        .then(function (prmRes) {
          return prmRes;
        })
        .then(function (prmData) {
          return prmData;
        });

      this.modalDelete.loading = false;
      this.modalDelete.show = false;
    },

    setActive(event) {
      const prevActive = document.querySelectorAll(".active");

      prevActive.forEach((e) => e.classList.remove("active"));

      // event.target.classList.add("active");

      if (event.target.parentElement) {
        event.target.parentElement.classList.add("active");
      }
    },

    getAll() {
      var api = new MEC_Plantillas_api();

      api
        .all(this.id_funcionario)
        .then(function (prmRes) {
          return prmRes;
        })
        .then(function (prmData) {
          if (
            Array.isArray(prmData.data.result) &&
            prmData.data.result.length > 0
          ) {
            varSelf.plantillas = prmData.data.result;
          }
        });
    },
  },
};
</script>

<style>
#home-section-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.home-section-title-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.home-section-subtitle {
  margin: 0;
  color: var(--white);
  font-size: 20px;
  text-align: center;
}

.home-section-title {
  margin: 0;
  color: var(--white);
  font-size: 40px;
  text-align: center;
  font-family: var(--special-font);
}

.home-section-content-wrapper {
  width: 100%;
  margin-top: 80px;
}
.home-section-new-card {
  width: 100%;
  display: flex;
  gap: 100px;
  flex-direction: column;
  align-items: center;
  margin-bottom: 4rem;
}

.home-section-new-title {
  margin: 0;
  text-align: center;
  color: var(--white);
}

.home-section-new-btn {
  all: unset;
  cursor: pointer;
  background-image: var(--grad-color-2);
  width: 150px;
  height: 48px;
  border-radius: 15px;
  padding: 2px;
}

.home-section-new-btn span {
  width: 100%;
  height: 100%;
  color: var(--white);
  background-color: var(--black);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  transition: background 0.3s ease-in-out;
}

.home-section-new-btn:hover span {
  background-color: transparent;
}

.home-section-table-card {
  width: 80%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  gap: 40px;
}

.home-section-table-title {
  text-align: center;
}

.home-section-table-btn {
  all: unset;
  cursor: pointer;
  background-image: var(--grad-color-2);
  width: 150px;
  height: 48px;
  border-radius: 15px;
  padding: 2px;
}

.home-section-table-btn span {
  width: 100%;
  height: 100%;
  color: var(--white);
  background-color: var(--black);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  transition: background 0.3s ease-in-out;
}

.home-section-table-btn:hover span {
  background-color: transparent;
}

.home-section-table-header {
  width: 100%;
  display: grid;
  grid-template-columns: 80px minmax(0, 1fr) 80px 100px 80px;
  padding: 10px 0;
  border-bottom: 1px solid #5f5f5f;
}

.home-section-table-label {
  color: var(--white);
  margin: 0;
}

.home-section-table {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.home-section-table-line-bg {
  width: 100%;
  min-height: 60px;
  padding: 2px;
  border-radius: 10px;
  background-image: var(--grad-color-2);
  position: relative;
}

.home-section-table-line {
  width: 100%;
  height: 100%;
  min-height: 60px;
  display: grid;
  grid-template-columns: 80px minmax(0, 1fr) 80px 100px 80px;
  border-radius: 8px;
  background-color: var(--black);
  grid-template-areas: "plant nomb val edit elim ";
}

.home-section-table-plantilla-field {
  grid-area: plant;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  font-size: 24px;
}

.home-section-table-plantilla-label-field {
  display: none;
}

.home-section-table-nombre-field {
  grid-area: nomb;
  padding: 0 5px;
  display: flex;
  align-items: center;
  color: var(--white);
}

.home-section-table-nombre-label-field {
  display: none;
}

.home-section-table-valorar-field,
.home-section-table-share-field,
.home-section-table-eliminar-field {
  display: flex;
  align-items: center;
  justify-content: center;
}

.home-section-table-valorar-field {
  grid-area: val;
  overflow: hidden;
}

.home-section-table-share-field {
  grid-area: edit;
  overflow: hidden;
}

.home-section-table-eliminar-field {
  grid-area: elim;
  overflow: hidden;
}

.home-section-valorar-btn,
.home-section-share-btn,
.home-section-eliminar-btn {
  all: unset;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  font-size: 20px;
}

.home-section-valorar-btn:disabled {
  background-color: var(--input-border);
}

.home-section-valorar-btn svg,
.home-section-share-btn svg,
.home-section-eliminar-btn svg {
  color: var(--white);
}

.home-section-valorar-btn span,
.home-section-share-btn span,
.home-section-eliminar-btn span {
  display: none;
}

.home-section-valorar-btn {
  background-color: var(--blue-shade-light);
}

.home-section-valorar-btn:hover {
  background-color: var(--hover-blue-shade-light);
}

.home-section-share-btn {
  background-color: var(--blue-shade-regular);
}

.home-section-share-btn:hover {
  background-color: var(--hover-blue-shade-regular);
}

.home-section-eliminar-btn {
  background-color: var(--blue-shade-dark);
}

.home-section-eliminar-btn:hover {
  background-color: var(--hover-blue-shade-dark);
}

@media screen and (max-width: 768px) {
  .home-section-table-card {
    width: 100%;
  }

  .home-section-table-header {
    display: none;
  }

  .home-section-table-line {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-template-rows: repeat(2, minmax(0, 1fr)) 0px;
    grid-template-areas:
      "plantlbl plant plant"
      "nomblbl nomb nomb"
      "val edit elim ";
    transition: all 0.3s ease-in-out;
  }

  .home-section-table-line.active {
    grid-template-rows: repeat(2, minmax(0, 1fr)) 70px;
  }

  .home-section-table-plantilla-label-field {
    grid-area: plantlbl;
    padding: 10px;
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 14px;
    color: var(--white);
  }

  .home-section-table-plantilla-field {
    padding: 10px;
    text-align: start;
    justify-content: flex-start;
    font-size: 14px;
  }

  .home-section-table-nombre-label-field {
    grid-area: nomblbl;
    padding: 0 5px;
    display: flex;
    align-items: center;
    color: var(--white);
    font-size: 14px;
  }

  .home-section-table-nombre-field {
    padding: 0 5px 5px 5px;
  }

  .home-section-valorar-btn,
  .home-section-share-btn,
  .home-section-eliminar-btn {
    width: 100%;
    height: 100%;
    flex-direction: column;
    gap: 0.5rem;
    border-radius: 0px;
  }

  .home-section-valorar-btn {
    border-radius: 0 0 0 7px;
  }

  .home-section-eliminar-btn {
    border-radius: 0 0 7px 0;
  }

  .home-section-valorar-btn span,
  .home-section-share-btn span,
  .home-section-eliminar-btn span {
    display: block;
    font-size: 14px;
    color: var(--white);
  }
}

/* ---------------------------------------------- Estilos modal registro */
#home-modal-warn,
#home-modal-evaluate,
#home-modal-share,
#home-modal-delete {
  font-family: var(--main-font);
}

#home-modal-warn + .modal-backdrop,
#home-modal-evaluate + .modal-backdrop,
#home-modal-share + .modal-backdrop,
#home-modal-delete + .modal-backdrop {
  background: rgba(0, 0, 0, 0.21);
  backdrop-filter: blur(7px);
}

#home-modal-share .modal-content {
  background-color: var(--black);
  border: solid 1px var(--white);
  border-radius: 20px;
}

#home-modal-warn .modal-content,
#home-modal-evaluate .modal-content,
#home-modal-delete .modal-content {
  background-color: var(--black);
  border-radius: 20px;
  border: double 1px transparent;
  background-image: linear-gradient(var(--black), var(--black)),
    var(--grad-color-2);
  background-origin: border-box;
  background-clip: padding-box, border-box;
}

#home-modal-warn .modal-header,
#home-modal-share .modal-header,
#home-modal-evaluate .modal-header,
#home-modal-delete .modal-header {
  padding: 2rem 0;
  border: none;
  position: relative;
}

.home-modal-warn-close-btn,
.home-modal-delete-close-btn,
.home-modal-share-close-btn,
.home-modal-evaluate-close-btn {
  all: unset;
  cursor: pointer;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  font-size: 35px;
  color: var(--white);
  transition: color 0.3s ease-in-out;
}

.home-modal-warn-close-btn:hover,
.home-modal-delete-close-btn:hover,
.home-modal-evaluate-close-btn:hover {
  color: var(--hover-white);
}

#home-modal-warn .modal-header .modal-title,
#home-modal-evaluate .modal-header .modal-title,
#home-modal-delete .modal-header .modal-title {
  width: 100%;
  font-weight: 700;
  text-align: center;
  color: var(--white);
}

.home-modal-evaluate-body {
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
}

.home-modal-evaluate-excel-btn {
  background: transparent;
  outline: none;
  border: none;
  display: flex;
  gap: 10px;
  color: var(--white);
  align-items: center;
  height: 48px;
  padding: 0 1rem;
  border-radius: 15px;
  transition: color 0.3s ease-in-out;
}

.home-modal-evaluate-excel-btn:focus {
  outline: 1px solid var(--white);
  outline-offset: 2px;
}

.home-modal-evaluate-excel-btn:hover {
  color: var(--hover-white);
}

.home-modal-evaluate-excel-icon {
  font-size: 20px;
}

.home-modal-share-body {
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.home-modal-share-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
}

.home-modal-share-form-title {
  margin: 0.5rem 0;
  color: var(--white);
  font-size: 40px;
  text-align: center;
  line-height: 64px;
}

.home-modal-share-form-txt {
  text-align: center;
  color: var(--white);
}

.home-modal-share-form-input {
  outline: none;
  padding: 0 1rem;
  border: 1px solid var(--input-border);
  color: var(--white);
  border-radius: 6px;
  height: 37px;
  width: 80%;
  background-color: transparent;
}

.home-modal-share-form-input::placeholder {
  color: var(--input-border);
}

.home-modal-share-form-input:focus {
  box-shadow: 0 0 10px 1px var(--white);
}

.home-modal-share-invalid-feedback {
  margin: 0;
  color: red;
  font-size: 12px;
  width: 100%;
  text-align: center;
}

.home-modal-share-form-btn {
  margin: 15px 0;
  border: none;
  outline: none;
  height: 37px;
  width: 80%;
  background-image: var(--grad-color-2);
  padding: 2px;
  border-radius: 10px;
}

.home-modal-share-form-btn span {
  background-color: var(--black);
  color: var(--white);
  border-radius: 8px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  transition: background 0.3s ease-in-out, color 0.3s linear;
}

.home-modal-share-form-btn:hover span {
  background-color: transparent;
  color: var(--black);
}

.home-modal-share-form-btn:disabled {
  background-image: none;
  background-color: var(--input-border);
  cursor: not-allowed;
}

.home-modal-share-form-btn:disabled span {
  background-color: var(--black);
  color: var(--input-border);
}

.home-modal-share-form-btn:disabled:hover span {
  background-color: var(--black);
  color: var(--input-border);
}

.home-modal-share-form-btn .lds-ring div {
  border: 4px solid var(--input-border);
  border-color: var(--input-border) transparent transparent transparent;
}

.home-modal-warn-body,
.home-modal-delete-body {
  width: 100%;
}

.home-modal-warn-txt,
.home-modal-evaluate-txt,
.home-modal-share-txt,
.home-modal-delete-txt {
  text-align: center;
  color: var(--white);
}

#home-modal-warn .modal-footer,
#home-modal-evaluate .modal-footer,
#home-modal-delete .modal-footer {
  border: none;
  justify-content: center;
}

.home-modal-warn-normal-btn,
.home-modal-evaluate-normal-btn,
.home-modal-delete-normal-btn {
  all: unset;
  cursor: pointer;
  width: 150px;
  height: 48px;
  border-radius: 15px;
  color: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: color 0.3s ease-in-out;
}

.home-modal-warn-normal-btn:hover,
.home-modal-evaluate-normal-btn:hover,
.home-modal-delete-normal-btn:hover {
  color: var(--hover-white);
}

.home-modal-warn-grad-btn,
.home-modal-evaluate-grad-btn,
.home-modal-delete-grad-btn {
  all: unset;
  cursor: pointer;
  width: 150px;
  height: 48px;
  padding: 2px;
  background-image: var(--grad-color-2);
  border-radius: 15px;
}

.home-modal-warn-grad-btn span,
.home-modal-evaluate-grad-btn span,
.home-modal-delete-grad-btn span {
  width: 100%;
  height: 100%;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  background-color: var(--black);
  color: var(--white);
  border-radius: 13px;
  transition: background 0.3s ease-in-out;
}

.home-modal-delete-grad-btn:disabled {
  background-image: none;
  background-color: var(--input-border);
  cursor: not-allowed;
}

.home-modal-delete-grad-btn:disabled span {
  color: var(--input-border);
}

.home-modal-delete-grad-btn:disabled span .lds-ring div {
  border: 4px solid var(--input-border);
  border-color: var(--input-border) transparent transparent transparent;
}

.home-modal-warn-grad-btn:hover span,
.home-modal-evaluate-grad-btn:hover span,
.home-modal-delete-grad-btn:hover span {
  background-color: transparent;
}

.home-modal-share-form-btn:focus,
.home-modal-warn-normal-btn:focus,
.home-modal-warn-grad-btn:focus,
.home-modal-evaluate-normal-btn:focus,
.home-modal-evaluate-grad-btn:focus,
.home-modal-delete-normal-btn:focus,
.home-modal-delete-grad-btn:focus {
  outline: 1px solid var(--white);
  outline-offset: 2px;
}
</style>
